import {Component, Injectable, OnInit} from "@angular/core";
import {MatDialog} from "@angular/material/dialog";
import {FormControl} from "@angular/forms";

@Component({
    selector: 'contract-edit-dialog-component',
    templateUrl: './contract.edit.dialog.component.html',
    styleUrls: ['./contract.edit.dialog.component.css'],
    standalone: false
})
export class ContractEditDialogComponent{
  name = new FormControl('');
}
